<div class="modal-header">
    <h6 class="modal-title" translate>
        TITLE.TITLE_ENTER_REMARKS
    </h6>
    <button type="button" class="close" aria-label="Close" (click)="Cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="textarea-wrapper d-flex flex-column">
        <textarea class="rounded maxHeight-remarks"
                  [(ngModel)]="Model"
                  [maxlength]="EnableMaxLimit ? MAX_LENGTH : null"
                  placeholder="{{'PH.PH_REMARK' | translate}}">
         </textarea>
        <small class="text-muted text-right pt-2">{{ Model ? Model.length : 0 }} <ng-container *ngIf="EnableMaxLimit">  / {{ MAX_LENGTH }}</ng-container></small>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="SubmitRemarks()" translate>BTN.BTN_SAVE</button>
    <button type="button" class="btn btn-secondary" (click)="Cancel()"><span translate>BTN.BTN_CANCEL</span></button>
</div>
